import {
  WSElement,
  WSList,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import {
  IPayeeResponse,
  IRequirementResponse,
  PayerPayeeStatus,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { useUserId } from "../../../../query/hooks/helpers";
import { ExtendedRequirementPreviewList } from "../../../Requirements/components/ExtendedRequirementPreviewList";
import { ExtendedRequirementsTable } from "../../../Requirements/components/ExtendedRequirementsTable";
import {
  RequirementContextType,
  RequirementTableItemData
} from "../../../Requirements/types";

export type EligibilityPanelProps = {
  payee: IPayeeResponse;
  noActions?: boolean;
  hasEligibleEngagements: boolean;
  requirements: IRequirementResponse[];
};

export const EligibilityRequirements: React.FC<EligibilityPanelProps> = ({
  hasEligibleEngagements,
  requirements,
  payee,
  noActions
}) => {
  const history = useHistory();
  const userId = useUserId();

  const completedLength = useMemo(() => {
    return requirements.filter(e => e.status === RequirementStatus.Complete)
      .length;
  }, [requirements]);

  const isRequirementsComplete = useMemo(() => {
    return requirements.every(e => e.status === RequirementStatus.Complete);
  }, [requirements]);

  const [showPreviews, setShowPreviews] = useState(false);

  const getOnViewDetails = (requirement: RequirementTableItemData) => {
    return "requirementId" in requirement
      ? (requirement: IRequirementResponse) =>
          history.push(
            `/member/payees/${payee.payeeId}/requirement/${requirement.requirementId}`
          )
      : undefined;
  };

  return (
    <WSElement>
      <WSList gap="L">
        <WSSectionToolbar
          title="Requirements"
          pill={
            payee.payerOwnedData.status === PayerPayeeStatus.Inactive
              ? {
                  icon: "archive",
                  text: "Archived",
                  theme: "neutral"
                }
              : requirements.length > 0
              ? {
                  icon: true,
                  text: `${completedLength} of ${requirements.length} completed`,
                  theme:
                    isRequirementsComplete && hasEligibleEngagements
                      ? "success"
                      : "warning"
                }
              : undefined
          }
          buttons={[
            {
              label: "",
              onClick: () => setShowPreviews(true),
              kind: showPreviews ? "Secondary" : "Link",
              icon: "grid",
              onlyIcon: true,
              size: "S"
            },
            {
              label: "",
              onClick: () => setShowPreviews(false),
              kind: !showPreviews ? "Secondary" : "Link",
              icon: "list",
              onlyIcon: true,
              size: "S"
            }
          ]}
        />

        {showPreviews ? (
          <ExtendedRequirementPreviewList
            requirements={requirements}
            contextType={RequirementContextType.Payee}
            getOnViewDetails={getOnViewDetails}
          />
        ) : (
          <ExtendedRequirementsTable
            requirements={requirements}
            contextType={RequirementContextType.Payee}
            showOverrideActions
            hideActions={noActions}
            getOnViewDetails={getOnViewDetails}
          />
        )}
      </WSList>
    </WSElement>
  );
};
